import styled from "styled-components";

export const Underlined = styled.div`
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
`;
export const Left = styled.div`
  width: 100%;
  text-align: left;
  padding-left: 20px;
`;
export const NoMatching = styled.div`
  color: var(--defaultTableCellTitle);
  width: 100%;
  text-align: center;
  padding-top: 27px;
`;

export const Wrapper = styled.div`
  font-size: 13px;
  text-align: left;
`;

export const RowsWrapper = styled.div`
  height: 150px;
  overflow: auto;
`;

export const HeaderCell = styled.div`
  font-weight: bold;
  background-color: #fcf9fc;
  color: var(--defaultTableCellTitle);
  text-align: left;
  padding-top: 18px;
  padding-bottom: 18px;
  display: flex;
  justify-content: center;
`;

export const Cell = styled.div`
  text-align: left;
  background-color: #fff;
  padding-top: 14px;
  padding-bottom: 14px;
  display: flex;
  justify-content: center;
`;
export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid var(--border);
  border-right: 1px solid var(--border);
  border-left: 1px solid var(--border);
  border-radius: 6px;
`;
